// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#333","menuActiveText":"#48b5a2","subMenuActiveText":"#333","menuBg":"#fff","menuHover":"#e8efff","subMenuBg":"#fff","subMenuHover":"#e8efff","theme":"#48b5a2"};